import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Label } from 'recharts';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const COLORS = ['#999999', '#006666'];

const CustomLegend = ({ payload }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      {payload.map((entry, index) => (
        <Box key={`item-${index}`} sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ backgroundColor: entry.color, width: 10, height: 10, marginRight: 1 }} />
          <Typography variant="body2" sx={{ color: '#555555' }}>
            {entry.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

const CompletionPieChart = ({ completed, total, showLegend = true, title = '' }) => {
  const data = [
    { name: 'Remaining', value: total - completed },
    { name: 'Completed', value: completed },
  ];

  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {title && (
        <Typography 
          sx={{ 
            color: '#333333', 
            fontFamily: 'Roboto', 
            fontWeight: 'bold', 
            fontSize: '16px',
            lineHeight: 1,
            letterSpacing: 0
          }}
        >
          {title}
        </Typography>
      )}
      <PieChart width={200} height={200}>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={40}
          outerRadius={80}
          fill="#8884d8"
          paddingAngle={5}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
          <Label
            value={`${percentage}%`}
            position="center"
            style={{
              fontSize: '24px',
              fontWeight: 'bold',
              fill: '#333333',
            }}
          />
        </Pie>
        <Tooltip />
      </PieChart>
      {showLegend && (
        <CustomLegend payload={data.map((entry, index) => ({ color: COLORS[index % COLORS.length], value: entry.name }))} />
      )}
    </Box>
  );
};

export default CompletionPieChart;